module.exports = __webpack_public_path__ + "img/IMG-20200119-WA0021.41dbce46.jpg";